import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MdArrowBack, MdFitnessCenter, MdPlayCircleOutline } from 'react-icons/md';
import API_URL from '../config/api';
import './ExerciseDetail.css';

function ExerciseDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [exercise, setExercise] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    const loadExercise = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await fetch(`${API_URL}/api/training/exercises/${id}`, {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await response.json();
        if (response.ok) {
          setExercise(data.exercise || null);
        } else {
          setError(data.error || 'Impossibile caricare il dettaglio dell\'esercizio.');
        }
      } catch (err) {
        setError('Errore di connessione durante il caricamento del dettaglio.');
      } finally {
        setLoading(false);
      }
    };

    loadExercise();
  }, [id, navigate]);

  const videoUrl = useMemo(() => {
    if (!exercise?.video_url) return '';
    if (exercise.video_url.startsWith('http')) return exercise.video_url;
    const normalizedPath = exercise.video_url.startsWith('/') ? exercise.video_url : `/${exercise.video_url}`;
    if (normalizedPath.startsWith('/uploads/')) {
      return `${API_URL}/api${normalizedPath}`;
    }
    return `${API_URL}${normalizedPath}`;
  }, [exercise]);

  const formatDate = (value) => {
    if (!value) return '—';
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return '—';
    return parsed.toLocaleString('it-IT');
  };

  return (
    <div className="exercise-detail-page">
      <div className="exercise-detail-header">
        <button
          type="button"
          className="exercise-detail-back-btn"
          onClick={() => navigate('/dashboard', { state: { initialSection: 'esercizi' } })}
        >
          <MdArrowBack />
          Torna indietro
        </button>
        <button type="button" className="exercise-detail-dashboard-btn" onClick={() => navigate('/dashboard')}>
          Dashboard
        </button>
      </div>

      <div className="exercise-detail-card">
        {loading ? (
          <div className="exercise-detail-placeholder">Caricamento dettaglio esercizio...</div>
        ) : error ? (
          <div className="exercise-detail-error">{error}</div>
        ) : !exercise ? (
          <div className="exercise-detail-error">Esercizio non trovato.</div>
        ) : (
          <>
            <div className="exercise-detail-title-row">
              <MdFitnessCenter className="exercise-detail-title-icon" />
              <div>
                <h1>{exercise.nome}</h1>
                <p>Dettaglio completo dell'esercizio</p>
              </div>
            </div>

            <div className="exercise-detail-grid">
              <div className="exercise-detail-item">
                <span>Gruppo muscolare</span>
                <strong>{exercise.gruppo_muscolare || '—'}</strong>
              </div>
              <div className="exercise-detail-item">
                <span>Macchinario</span>
                <strong>{exercise.machine_name || 'Corpo libero'}</strong>
              </div>
              <div className="exercise-detail-item">
                <span>Creato il</span>
                <strong>{formatDate(exercise.created_at)}</strong>
              </div>
              <div className="exercise-detail-item">
                <span>Ultimo aggiornamento</span>
                <strong>{formatDate(exercise.updated_at)}</strong>
              </div>
            </div>

            <div className="exercise-detail-video-block">
              <div className="exercise-detail-video-title">
                <MdPlayCircleOutline />
                <span>Video esecuzione</span>
              </div>

              {videoUrl ? (
                <video className="exercise-detail-video" controls preload="metadata" src={videoUrl}>
                  Il browser non supporta la riproduzione video.
                </video>
              ) : (
                <p className="exercise-detail-video-empty">Nessun video disponibile per questo esercizio.</p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ExerciseDetail;
